import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { SitesSettings } from '@/areas/settings/manufacturing/OrganizationSettings/SitesSettingsPage';
import { canViewSitesSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/sites')({
    staticData: {
        access: { permissions: canViewSitesSettings },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <SitesSettings />;
}
